module.exports = __webpack_public_path__ + "static/media/perpara108gj.c01cd1b1.jpg";